import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {DjangoPage, DjangoPaginator} from '../django-paginator';
import {map} from 'rxjs/operators';
import {CompanyDetails} from '../admin/company-search.service';

export interface AffiliateStat {
  year: number;
  month: number;
  orders_started: number;
  orders_finished: number;
  ticket_amount: number;
  clicks_amount: number;
  total_affiliate_revenue: string;
  total_affiliate_revenue_currency: string;
}

export interface AffiliateInvoice {
  id: number;
  created_at: string;
  invoice_date: string;
  invoice_number: string;
  total_amount_excluding_vat: string;
  total_amount_including_vat: string;
  currency: string;
}

export interface Company {
  address: {};
  automated_fb_import_email: boolean;
  company_number: number;
  customer_id: number;
  email: string;
  id_company: number;
  info: string;
  is_partner: boolean;
  name: string;
  phone_number: number;
  type: string;
  vat_number: number;
}

export interface CompanyUser {
  email: string;
  contact_email: string;
  first_name: string;
  id: number;
  last_name: string;
  phone: string;
  profile_id: number;
  profile_photo: string;
  isNew?: boolean;
  full_name?: string;
  name?: string;
}

@Injectable()
export class CompanyApiService {
  constructor(private http: HttpClient) {}

  affiliateStats = (id, params = null) =>
    this.http.get<AffiliateStat[]>(`/rest-api/v1/companies/${id}/stats/affiliate`, {params});

  affiliateInvoices = id => new DjangoPaginator<AffiliateInvoice>(`/rest-api/v1/companies/${id}/invoices`, this.http);

  fetchCompany = id => this.http.get<Company>(`/rest-api/v1/companies/${id}/`);

  sendLoginInformation = compID => this.http.post(`/rest-api/v1/companies/${compID}/last_login/`, null);

  getCompanyUsers = (companyID, params = null) =>
    this.http.get<DjangoPage<CompanyUser>>(`/rest-api/v1/companies/${companyID}/users`, {params});

  inviteUser = (companyID, body) => this.http.post(`/rest-api/v1/companies/${companyID}/users`, body);

  getLegalEntities = (companyID, params = null) => {
    return this.http
      .get<DjangoPage<any>>(`rest-api/v1/companies/${companyID}/legal-entities`, {
        params,
      })
      .pipe(map(res => res.results));
  };

  createLegalEntities = (companyID, payload) => {
    return this.http.post(`rest-api/v1/companies/${companyID}/legal-entities`, payload);
  };

  updateLegalEntity = (companyID, subcompanyID, payload) => {
    return this.http.put(`rest-api/v1/companies/${companyID}/legal-entities/${subcompanyID}`, payload);
  };

  getVatScenario = (companyID, country) => {
    return this.http.get(`rest-api/v1/companies/${companyID}/legal-entities/vat_scenario?country=${country}`);
  };

  checkVatNumber = vat_no => {
    return this.http.get(`rest-api/v1/admin/companies/utils/check_vat_no?vat_no=${vat_no}`);
  };
}
